import { Author } from './author';
import { z } from 'zod';

export type JobRequest = z.infer<typeof JobRequest>;
export type IndexJobRequest = z.infer<typeof IndexJobRequest>;
export type CancelJobRequest = z.infer<typeof CancelJobRequest>;
export type IndexJobProgress = z.infer<typeof IndexJobProgress>;

export const JobRequest = z.object({
  parentJobId: z.string().optional(),
  triggeredOn: z.coerce.date().optional(),
  triggeredBy: Author.optional(),
  time: z.coerce.date().optional(),
});

export const IndexJobRequest = JobRequest.extend({
  db: z.string(),
  coll: z.string(),
  name: z.string(),
  actual: z
    .object({
      db: z.string(),
      coll: z.string(),
    })
    .optional(),
});

export const CancelJobRequest = z.object({
  id: z.string(),
});

export const IndexJobProgress = z.preprocess(
  (arg) => {
    if (typeof arg === 'number') {
      return { completed: arg, errors: 0 };
    }
    return arg;
  },
  z.object({
    completed: z.number(),
    errored: z.number(),
  }),
);
